import type { TabData } from 'components/DeviceView/deviceViewTypes';
import { useLocale } from 'containers/App/LocaleContext';
import { DownloadDeviceJson } from 'containers/DownloadDeviceJson/DownloadDeviceJson';
import { type FC, memo } from 'react';
import { useSnapshotId } from 'utils/hooks/useSnapshotId';
import { isDeviceDetailData } from '../helpers/isDeviceDetailData';

interface Props {
  tabData?: TabData;
}

const BareDeviceViewContentDownloadJsonButton: FC<Props> = (props) => {
  const currentSnapshotId = useSnapshotId();
  const msg = useLocale();
  if (!props.tabData) {
    return null;
  }

  const {
    tabData: { device },
  } = props;

  if (isDeviceDetailData(device) && device.sn && currentSnapshotId) {
    return (
      <DownloadDeviceJson
        btnText={msg.deviceView.btnDownloadJson}
        snapshot={currentSnapshotId}
        sn={device.sn}
      />
    );
  }
  return null;
};

export const DeviceViewContentDownloadJsonButton = memo(
  BareDeviceViewContentDownloadJsonButton,
);
